import { Button } from "../../components";
import { generalIcons } from "../../utils/constants";
import { addChain } from "../../utils/helper";

function AddMetamask() {
  return (
    <div className="metamaskCard mt-auto w-full h-auto">
      <Button
        onClick={addChain}
        className="hover:!opacity-80 relative gap-2 !px-4 lg:!px-6 !py-3 hover-btn !text-[12px]/4 lg:!text-[16px]/[24px] !font-black !font-serif"
      >
        <span className="size-5 lg:size-[22px] *:size-full">
          {generalIcons.wallet}
        </span>
        ADD VANAR TO WALLET
      </Button>
    </div>
  );
}

export default AddMetamask;
